// For Get insurance_carriers
export const GET_REFUND_POLICY = "GET_REFUND_POLICY"
export const GET_REFUND_POLICY_SUCCESS = "GET_REFUND_POLICY_SUCCESS"
export const GET_REFUND_POLICY_ERROR = "GET_REFUND_POLICY_ERROR"

export const POST_REFUND_POLICY = "POST_REFUND_POLICY"
export const POST_REFUND_POLICY_SUCCESS = "POST_REFUND_POLICY_SUCCESS"
export const POST_REFUND_POLICY_ERROR = "POST_REFUND_POLICY_ERROR"

export const GET_LATEST_REFUND_POLICY = "GET_LATEST_REFUND_POLICY"
export const GET_LATEST_REFUND_POLICY_SUCCESS = "GET_LATEST_REFUND_POLICY_SUCCESS"
export const GET_LATEST_REFUND_POLICY_ERROR = "GET_LATEST_REFUND_POLICY_ERROR"
